// Custom Liste Studyosu — uretim yolu. Liste calismasinin katmanlarindan KODLA karar verilir
// (model her calismada farkli derdi; liste tipi de kodla turetiliyor):
//   - template: yazilar normal fontla basilir, sablon kurulur (3. adim), ornekler ve siparis kodla
//   - ai: kodla kurmak zor/guvenilmez (harf harf desenli yazinin rengini alici seciyor, menuden
//     secim, tasarim seti, arka/kol baskisi) — 3. adim atlanir, ornekler ve siparis AI ile cizilir
// Kullanici secerse (override) kural sonucunun onune gecer.

import type { ApparelStudy } from "../types/custom-study";

export type ProductionMode = "template" | "ai";
export interface ProductionDecision { mode: ProductionMode; reasonTr: string; override?: boolean }

export function decideProduction(s: Pick<ApparelStudy, "layers" | "questions" | "listingTypes">): ProductionDecision {
  const buyer = s.layers.filter((l) => l.source !== "fixed" || l.colorRule === "buyer_pick");
  const glyphPick = s.layers.find((l) => l.kind === "glyph_text" && (l.colorRule === "buyer_pick"
    || s.questions.some((q) => q.type === "dropdown" && q.layerKeys.includes(l.key))));
  if (glyphPick) return { mode: "ai", reasonTr: `"${glyphPick.labelTr}" harf harf çizilmiş ve rengini alıcı seçiyor; harf setini her renge kodla boyamak güvenilir değil.` };
  const slot = s.layers.find((l) => l.kind === "graphic_slot");
  if (slot || s.listingTypes.includes("menu_pick") || s.listingTypes.includes("design_set")) {
    return { mode: "ai", reasonTr: `${slot ? `"${slot.labelTr}" menüden seçilen bir grafik` : "Liste menüden seçim / tasarım seti"}; şablon bu tipi henüz desteklemiyor.` };
  }
  const side = buyer.find((l) => l.side !== "front");
  if (side) return { mode: "ai", reasonTr: `"${side.labelTr}" ön yüz dışında (${side.side}); şablon yalnız ön baskıyı kuruyor.` };
  return { mode: "template", reasonTr: "Yazılar fontla basılabiliyor; şablon kurulur, örnekler ve sipariş kodla basılır." };
}

/** Kaydedilmis karar (kullanici secimi) varsa o, yoksa kural */
export function productionOf(s: Pick<ApparelStudy, "layers" | "questions" | "listingTypes"> & { production?: ProductionDecision }): ProductionDecision {
  return s.production?.override ? s.production : decideProduction(s);
}
